import { render, staticRenderFns } from "./SampleBinsDialog.vue?vue&type=template&id=054941c8&scoped=true"
import script from "./SampleBinsDialog.vue?vue&type=script&lang=js"
export * from "./SampleBinsDialog.vue?vue&type=script&lang=js"
import style0 from "./SampleBinsDialog.vue?vue&type=style&index=0&id=054941c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054941c8",
  null
  
)

export default component.exports